import type * as React from "react";

export type HeadingLevel = "1" | "2" | "3" | "4" | "5" | "6" | 1 | 2 | 3 | 4 | 5 | 6;
export interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  level: HeadingLevel;
  ref?: React.Ref<HTMLHeadingElement>;
  textReveal?: string;
}

const Heading = ({ children, level, textReveal, className, ref, style, ...props }: HeadingProps) => {
  const Tag = `h${level}` as const;
  return (
    <Tag {...props} className={className} ref={ref} style={style}>
      {children}
    </Tag>
  );
};

Heading.displayName = "Heading";

export { Heading };
